import React, { useState } from 'react';
import { getFirestore, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { format } from 'date-fns';

const KERBLET_BLUE = '#3F51B5';

const ApproveReviewModal = ({ review, open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [error, setError] = useState(null);

  if (!open) return null;

  const handleApprove = async () => {
    setLoading(true);
    setError(null);
    try {
      const db = getFirestore();
      await updateDoc(doc(db, 'reviews', review.id), { approved: true });
      onClose(true);
    } catch (err) {
      setError('Failed to approve review.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    try {
      const db = getFirestore();
      await deleteDoc(doc(db, 'reviews', review.id));
      onClose(true);
    } catch (err) {
      setError('Failed to delete review.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
        <h2 className="text-xl font-bold mb-4">Approve Review?</h2>
        <div className="space-y-3 mb-4">
          <div>
            <label className="block text-xs text-gray-500 mb-1">Space Name</label>
            <input className="w-full border rounded px-3 py-2 bg-gray-100" value={review.spacename || ''} readOnly />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Space Address</label>
            <input className="w-full border rounded px-3 py-2 bg-gray-100" value={review.spaceaddr || ''} readOnly />
          </div>
          <div className="flex gap-2">
            <div className="flex-1">
              <label className="block text-xs text-gray-500 mb-1">User Name</label>
              <input className="w-full border rounded px-3 py-2 bg-gray-100" value={review.username || ''} readOnly />
            </div>
            <div className="w-28">
              <label className="block text-xs text-gray-500 mb-1">Rate</label>
              <input className="w-full border rounded px-3 py-2 bg-gray-100" value={review.rate || 0} readOnly />
            </div>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Description</label>
            <textarea className="w-full border rounded px-3 py-2 bg-gray-100" value={review.review || ''} readOnly rows={2} />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Date</label>
            <input className="w-full border rounded px-3 py-2 bg-gray-100" value={review.date ? format(review.date.toDate ? review.date.toDate() : new Date(review.date), 'MMM dd, yyyy') : ''} readOnly />
          </div>
        </div>
        {error && <div className="text-red-600 mb-2 text-sm">{error}</div>}
        {/* Modal Actions */}
        <div className="flex items-center justify-between mt-6">
          <button
            className="text-gray-600 font-semibold px-4 py-2 rounded hover:bg-gray-100"
            onClick={() => onClose(false)}
            disabled={loading}
          >
            CANCEL
          </button>
          <div className="flex-1 flex justify-center">
            {confirmDelete ? (
              <>
                <button
                  className="text-white font-semibold px-4 py-2 rounded bg-red-600 hover:bg-red-700 mr-2"
                  onClick={handleDelete}
                  disabled={loading}
                >
                  Confirm Delete
                </button>
                <button
                  className="text-gray-600 font-semibold px-4 py-2 rounded hover:bg-gray-100"
                  onClick={() => setConfirmDelete(false)}
                  disabled={loading}
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className="text-white font-semibold px-4 py-2 rounded"
                style={{ background: '#e53935' }}
                onClick={() => setConfirmDelete(true)}
                disabled={loading}
              >
                DELETE
              </button>
            )}
          </div>
          <button
            className="font-semibold px-4 py-2 rounded text-white"
            style={{ background: KERBLET_BLUE }}
            onClick={handleApprove}
            disabled={loading}
          >
            APPROVE
          </button>
        </div>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-60 rounded-lg">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApproveReviewModal; 